import { connect } from "react-redux";
import MiniBag from "./MiniBag";
import { getBagItems } from "../../state/modules/miniBag";

const mapStateToProps = state => ({
  items: getBagItems(state)
});

export default connect(mapStateToProps)(MiniBag);



// WEBPACK FOOTER //
// ./template/components/MiniBag/index.js